import { render, staticRenderFns } from "./salesPerformance.vue?vue&type=template&id=51fbfcae&scoped=true&"
import script from "./salesPerformance.vue?vue&type=script&lang=js&"
export * from "./salesPerformance.vue?vue&type=script&lang=js&"
import style0 from "./salesPerformance.vue?vue&type=style&index=0&id=51fbfcae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fbfcae",
  null
  
)

export default component.exports